export var getNewExchangeFlightPrice = function (order) {
    return {
        priceToPay: order.prices.priceToPay,
        charges: {
            amount: order.prices.agencyChargesForExare.amount + order.prices.exchangeAirlinePenalty.amount,
            currency: order.prices.priceToPay.currency
        }
    };
};
